import { onWindowResize } from '../utils/window-resize';

const accordionSelector = '[data-action="accordion"]';
let activeIndex = -1;
const smQuery = window.matchMedia('(min-width: 768px)');
const lgQuery = window.matchMedia('(min-width: 1200px)');
const xxlQuery = window.matchMedia('(min-width: 1920px)');
let itemsPrRow;

function openAccordion(trigger, content) {
    const accordionItem = trigger.closest('[data-action="accordion"]');
    const allAccordions = accordionItem.parentNode.querySelectorAll('[data-action="accordion"]');
    activeIndex = Array.prototype.indexOf.call(allAccordions, accordionItem);
    content.style.height = `${content.scrollHeight}px`;

    if (trigger.classList.contains('company-overview__item-headline') && itemsPrRow != 1) {
        /*
            This is a special accordion with 4 side-by-side on large screens - and the content goes full width of module.
            Because of that, we need to position it absolute - and push the accordion items below down, when the content of an item opens.
        */

        const item = trigger.closest('.company-overview__item');

        if (item) {
            updateAccordionItemPositions('open', item, content.scrollHeight);
        }

        const rows = [];

        for (let a = 0; a < allAccordions.length; a += itemsPrRow) {
            rows.push(Array.from(allAccordions).slice(a, a + itemsPrRow));
        }

        const lastRow = rows[rows.length - 1];
        const lastRowHasCurrentElement = Array.from(lastRow).indexOf(accordionItem) != -1;

        if (lastRowHasCurrentElement) {
            accordionItem.style.marginBottom = `${content.scrollHeight}px`;
        }
    }

    content.addEventListener('transitionend', function(e) {
        if (e.propertyName === 'height') {
            content.style.height = null;
            window.history.pushState(null, null, `#${content.id}`);
        }
    });

    content.setAttribute('aria-hidden', false);
    trigger.setAttribute('aria-expanded', true);
}

function setItemsPrRow() {
    itemsPrRow = xxlQuery.matches ? 6 : (lgQuery.matches ? 4 : (smQuery.matches ? 3 : 1));
}

function closeAccordion(trigger, content, updatePositions = false) {
    const accordionItem = trigger.closest('[data-action="accordion"]');
    const allAccordions = accordionItem.parentNode.querySelectorAll('[data-action="accordion"]');
    activeIndex = Array.prototype.indexOf.call(allAccordions, accordionItem);
    content.style.height = `${content.scrollHeight}px`;

    if (trigger.classList.contains('company-overview__item-headline') && itemsPrRow != 1) {
        /*
            This is a special accordion with 4 side-by-side on large screens - and the content goes full width of module.
            Because of that, we need to position it absolute - and push the accordion items below down, when the content of an item opens.
        */

        const item = trigger.closest('.company-overview__item');

        if (item && updatePositions) {
            updateAccordionItemPositions('close', item, content.scrollHeight);
        }

        const rows = [];

        for (let a = 0; a < allAccordions.length; a += itemsPrRow) {
            rows.push(Array.from(allAccordions).slice(a, a + itemsPrRow));
        }

        const lastRow = rows[rows.length - 1];
        const lastRowHasCurrentElement = Array.from(lastRow).indexOf(accordionItem) != -1;

        if (lastRowHasCurrentElement) {
            accordionItem.style.marginBottom = null;
        }
    }

    setTimeout(() => {
        content.style.height = '0';
    }, 0);

    content.setAttribute('aria-hidden', true);
    trigger.setAttribute('aria-expanded', false);
}

function updateAccordionItemPositions(action, currentItem, height) {
    const allItems = currentItem.parentNode.querySelectorAll('.company-overview__item');

    allItems.forEach((item, index) => {
        if (item == currentItem) {
            const mod = index % itemsPrRow;
            const start = index + (itemsPrRow - mod);
            const end = start + itemsPrRow;

            console.log('itemsPrRow', itemsPrRow);
            console.log(`${index} / ${itemsPrRow}`, mod);
            console.log('start', start);
            console.log('end', end);

            for (let a = start; a < end; a++) {
                if (allItems[a]) {
                    allItems[a].style.marginTop = action == 'open' ? `${height}px` : null;
                }
            }
        } else {
            const itemHeadline = item.querySelector('.accordion__headline');

            if (itemHeadline.getAttribute('aria-expanded') == 'true') {
                const itemContentWrap = item.querySelector('.accordion__content-wrap');
                const updatePositions = index < activeIndex;

                closeAccordion(itemHeadline, itemContentWrap, updatePositions);
            }
        }
    });
}

function openAccordByHashId() {
    if (window.location.hash.indexOf('accordion') > -1) {
        const content = document.getElementById(window.location.hash.replace('#', ''));

        if (content) {
            const accordion = document.getElementById(content.getAttribute('aria-labelledby'));
            accordion.click();
        }
    }
}

function toggleAccordion(e) {
    if (e && !(e.ctrlKey || e.metaKey || e.shiftKey)) {
        e.preventDefault();
    }

    const trigger = e.currentTarget;
    const accordion = trigger.closest(accordionSelector);

    if (accordion) {
        const content = accordion.querySelector('[aria-labelledby]');
        const opened = trigger.getAttribute('aria-expanded') == 'true';
        const updatePositions = trigger.classList.contains('company-overview__item-headline');

        if (opened) {
            closeAccordion(trigger, content, updatePositions);
            activeIndex = -1;
        } else {
            openAccordion(trigger, content);
        }
    }
}

function setupAccordion(accordionTrigger) {
    accordionTrigger.addEventListener('click', toggleAccordion);
}

window.addEventListener('keydown', e => {
    const focusedElement = document.activeElement;
    const closestElement = focusedElement.closest(accordionSelector);

    if (focusedElement && closestElement) {

        // Focus previous accordion
        if (e.key === 'ArrowUp') {
            const newFocusedElement = closestElement.previousElementSibling;
            if (newFocusedElement && newFocusedElement.querySelector('[aria-controls]')) {
                newFocusedElement.querySelector('[aria-controls]').focus();
            }
        }

        // Focus next accordion
        if (e.key === 'ArrowDown') {
            const newFocusedElement = closestElement.nextElementSibling;
            if (newFocusedElement && newFocusedElement.querySelector('[aria-controls]')) {
                newFocusedElement.querySelector('[aria-controls]').focus();
            }
        }

        // Focus first accordion
        if (e.key === 'Home') {
            const newFocusedElement = closestElement.parentNode.querySelector(`${accordionSelector}:first-child`);
            if (newFocusedElement && newFocusedElement.querySelector('[aria-controls]')) {
                e.preventDefault();
                newFocusedElement.querySelector('[aria-controls]').focus();
            }
        }

        // Focus last accordion
        if (e.key === 'End') {
            const newFocusedElement = closestElement.parentNode.querySelector(`${accordionSelector}:last-child`);
            if (newFocusedElement && newFocusedElement.querySelector('[aria-controls]')) {
                e.preventDefault();
                newFocusedElement.querySelector('[aria-controls]').focus();
            }
        }
    }
});

export function setupAccordions() {
    const accordions = document.querySelectorAll(accordionSelector);

    if (accordions) {

        accordions.forEach(accordion => {
            const accordionTrigger = accordion.querySelector('[aria-controls]');

            if (accordionTrigger) {
                setupAccordion(accordionTrigger);
            }
        });

        openAccordByHashId();
    }

    onWindowResize(() => {
        setItemsPrRow();
    });

    window.addEventListener('hashchange',openAccordByHashId);
}

setItemsPrRow();
